// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Logo Component Styles
 * Secure, responsive logo component styling
 */

.logo-container {
    display: flex;
    align-items: center;
    gap: 8px;
}

.logo-image {
    max-width: 100%;
    height: auto;
    object-fit: contain;
    transition: opacity 0.3s ease;
}

.logo-image.loading {
    opacity: 0.7;
}

.logo-image.loaded {
    opacity: 1;
}

.logo-text {
    font-weight: 600;
    color: inherit;
    white-space: nowrap;
}

.logo-fallback {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    border: 1px solid #e0e0e0;
    transition: all 0.3s ease;
}

.logo-fallback:hover {
    background-color: #f8f8f8;
    border-color: #d0d0d0;
}

.fallback-icon {
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .logo-container {
        gap: 6px;
    }

    .logo-text {
        font-size: 0.9em;
    }
}

@media (max-width: 480px) {
    .logo-container {
        gap: 4px;
    }

    .logo-text {
        font-size: 0.8em;
    }
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
    .logo-fallback {
        background-color: #2a2a2a;
        border-color: #404040;
        color: #ffffff;
    }

    .logo-fallback:hover {
        background-color: #3a3a3a;
        border-color: #505050;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/common/Logo.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA,2BAA2B;AAC3B;IACI;QACI,QAAQ;IACZ;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,QAAQ;IACZ;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA,sBAAsB;AACtB;IACI;QACI,yBAAyB;QACzB,qBAAqB;QACrB,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,qBAAqB;IACzB;AACJ","sourcesContent":["/**\n * Logo Component Styles\n * Secure, responsive logo component styling\n */\n\n.logo-container {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.logo-image {\n    max-width: 100%;\n    height: auto;\n    object-fit: contain;\n    transition: opacity 0.3s ease;\n}\n\n.logo-image.loading {\n    opacity: 0.7;\n}\n\n.logo-image.loaded {\n    opacity: 1;\n}\n\n.logo-text {\n    font-weight: 600;\n    color: inherit;\n    white-space: nowrap;\n}\n\n.logo-fallback {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    border: 1px solid #e0e0e0;\n    transition: all 0.3s ease;\n}\n\n.logo-fallback:hover {\n    background-color: #f8f8f8;\n    border-color: #d0d0d0;\n}\n\n.fallback-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n    .logo-container {\n        gap: 6px;\n    }\n\n    .logo-text {\n        font-size: 0.9em;\n    }\n}\n\n@media (max-width: 480px) {\n    .logo-container {\n        gap: 4px;\n    }\n\n    .logo-text {\n        font-size: 0.8em;\n    }\n}\n\n/* Dark mode support */\n@media (prefers-color-scheme: dark) {\n    .logo-fallback {\n        background-color: #2a2a2a;\n        border-color: #404040;\n        color: #ffffff;\n    }\n\n    .logo-fallback:hover {\n        background-color: #3a3a3a;\n        border-color: #505050;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
